import * as actionTypes from "../action-types";

const initialState = {
    //! Customer
    customerData: [],
    customerDataById: [],

    //! Customer Report Wallet
    customerReportWalletData: []
};

const partnerReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        //! Customer
        case actionTypes.SET_CUSTOMERS:
            return { ...state, customerData: payload };

        case actionTypes.SET_CUSTOMER_BY_ID:
            return { ...state, customerDataById: payload };

        //! Customer Report Wallet
        case actionTypes.SET_CUSTOMER_REPORT_WALLETS:
            return { ...state, customerReportWalletData: payload };

        default:
            return state;
    }
};

export default partnerReducer;